<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-info" title="Associa Utenti" @click="onAssociaUtenti(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="user"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Visualizza Farmacia" @click="onView(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="eye"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Farmacia" @click="onEdit(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Farmacia" @click="onDelete(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"> </font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <farmacie-utenti-associa-modal-edit-component-vue ref="cmpFarmacieUtentiAssociaModalEdit" @afterSave="onAfterSave"></farmacie-utenti-associa-modal-edit-component-vue>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import FarmacieUtentiAssociaModalEditComponentVue from "./FarmacieUtentiAssociaModalEditComponent.vue";

export default {
    name: "FarmacieListComponent",
    mixins: [UtilityMixin],
    components: { FarmacieUtentiAssociaModalEditComponentVue },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            fields: [
                { label: "*", key: "index", thStyle: "width: 3rem" },
                { label: "Farmacia", key: "farmacia" },
                { label: "Comune", key: "denominazioneComune" },
                { label: "Titolare", key: "titolare" },
                { label: "Email", key: "email" },
                { label: "", key: "actions", thClass: "text-right", tdClass: "text-right" },
            ],
            pathResource: "/farmacie",
        };
    },
    methods: {
        loadData() {
            let me = this;
            this.openShowModalLoading();
            let filtro = sessionStorage["filtroFarmacie"] ? JSON.parse(sessionStorage["filtroFarmacie"]) : null;
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;

            this.closeShowModalLoading();
        },
        loadDataError(error) {
            this.closeShowModalLoading();
            console.log("Errore nel caricamento dei dati", error);
        },
        onEdit(item) {
            let me = this;
            me.$router.push({ name: "FarmacieEdit", params: { id: item.id } });
        },
        onView(item) {
            let me = this;
            me.$router.push({ name: "FarmacieView", params: { id: item.id } });
        },
        onDelete(item) {
            let me = this;
            let message = "Sei sicuro di voler cancellare la farmacia '" + (item.farmacia || item.id) + "'?";
            me.$bvModal
                .msgBoxConfirm(message, {
                    title: "Conferma eliminazione",
                    size: "md",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Sì",
                    cancelTitle: "No",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((confirmed) => {
                    if (confirmed) {
                        UtilityMixin.methods.deleteResource(me.pathResource + "/" + item.id, me.loadDeleteSuccess, me.loadDeleteError);
                    }
                })
                .catch((error) => {
                    console.log("Conferma cancellazione annullata", error);
                });
        },
        loadDeleteSuccess() {
            let me = this;
            me.loadData();
        },
        loadDeleteError(error) {
            console.log("Errore nella cancellazione del record", error);
        },
        onAssociaUtenti(item) {
            this.$refs.cmpFarmacieUtentiAssociaModalEdit.init(item.id);
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
